// Modül 2 - Havayolları Adaydan Ne Bekler? - TAM İNTERAKTİF İÇERİKLER
// Tüm üniteler ve tüm dersler

const cabinCrewContentsM2Interactive = {
  // ==================== ÜNİTE 1: DEĞERLENDİRME KRİTERLERİ ====================
  'CM-M2-U1-L1': {
    lesson_id: 'CM-M2-U1-L1',
    title: 'Takım Uyumu',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '👥 Takım Uyumu Neden Kritik?',
      intro: 'Uçuş ekibi bir takımdır ve uyum şarttır!',
      categories: [
        { icon: '✈️', title: 'Uçuş Güvenliği', examples: 'Ekip koordinasyonu', desc: 'Hayat kurtaran uyum' },
        { icon: '🔄', title: 'Değişen Ekipler', examples: 'Her uçuşta farklı', desc: 'Hızlı adaptasyon' },
        { icon: '🌍', title: 'Rotasyon', examples: 'Farklı rotalar', desc: 'Esneklik gerektirir' },
        { icon: '⚠️', title: 'Ego = Tehlike', examples: 'Bireyselcilik yok', desc: 'Takım önce gelir' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Havayolu şirketleri neden takım uyumuna önem verir?',
        options: [
          { text: 'Sadece sosyal ortam için', isCorrect: false, feedback: '❌ Hayır, güvenlik için!' },
          { text: 'Uçuş güvenliği ve koordinasyon için', isCorrect: true, feedback: '✅ Acil durumlarda uyumlu ekip hayat kurtarır!' },
          { text: 'Maaş tasarrufu için', isCorrect: false, feedback: '❌ Takım uyumunun maaşla ilgisi yok.' }
        ]
      }
    }
  },

  'CM-M2-U1-L2': {
    lesson_id: 'CM-M2-U1-L2',
    title: 'İletişim Becerileri',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '💬 Etkili İletişim',
      intro: 'Kabin memuru = profesyonel iletişimci',
      facts: [
        { icon: '👂', title: 'Aktif Dinleme', text: 'Sadece duymak değil, anlamak' },
        { icon: '😊', title: 'Empati', text: 'Yolcunun yerine koymak' },
        { icon: '🗣️', title: 'Net İfade', text: 'Açık ve anlaşılır konuşma' },
        { icon: '🌐', title: 'Çok Dilli', text: 'İngilizce + ekstra dil avantaj' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İletişimde en önemli beceri?',
        options: [
          { text: 'Çok konuşmak', isCorrect: false, feedback: '❌ Çok konuşmak değil, doğru konuşmak!' },
          { text: 'Aktif dinleme ve empati', isCorrect: true, feedback: '✅ Önce anla, sonra cevap ver!' },
          { text: 'Yüksek sesle konuşmak', isCorrect: false, feedback: '❌ Ses tonu dengeli olmalı.' }
        ]
      }
    }
  },

  'CM-M2-U1-L3': {
    lesson_id: 'CM-M2-U1-L3',
    title: 'Senaryo: Kriter Testi',
    type: 'scenario',
    duration: 5,
    xp: 30,
    scenario: {
      question: '🎯 SENARYO: Grup Tartışması',
      context: 'Grup mülakatındasınız. Bir aday sürekli sözünüzü kesiyor ve fikirlerinizi eleştiriyor. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Sakin kalır, nazikçe söz hakkı isterim ve fikrimi ifade ederim', isCorrect: true },
        { id: 'B', text: 'Ben de onun sözünü keserim', isCorrect: false },
        { id: 'C', text: 'Sessiz kalır, konuşmayı bırakırım', isCorrect: false },
        { id: 'D', text: 'Jüriye şikayet ederim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Sakin kalmak ve profesyonelliği korumak takım uyumunu gösterir.',
        wrong: '❌ Jüri sizi grup içinde nasıl davrandığınıza göre değerlendiriyor. Sakin ve profesyonel olun.'
      },
      explanation: 'Havayolları adayların stres altında bile sakin kalabilmesini ve profesyonel davranabilmesini ister.'
    }
  },

  // ==================== ÜNİTE 2: FİZİKSEL GEREKLİLİKLER ====================
  'CM-M2-U2-L1': {
    lesson_id: 'CM-M2-U2-L1',
    title: 'Boy ve Erişim Mesafesi',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '📏 Boy ve Erişim Kriterleri',
      intro: 'Güvenlik için minimum boy şartları var',
      facts: [
        { icon: '📏', title: 'Minimum Boy', text: 'Genellikle 160 cm (kadın), 170 cm (erkek)' },
        { icon: '🤚', title: 'Arm Reach', text: '212 cm üzeri erişim mesafesi' },
        { icon: '✈️', title: 'Overhead Bin', text: 'Üst dolaplara rahat erişim' },
        { icon: '🚪', title: 'Acil Çıkış', text: 'Kapı mekanizmalarına ulaşım' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Boy kriteri neden önemli?',
        options: [
          { text: 'Sadece estetik için', isCorrect: false, feedback: '❌ Estetik değil, güvenlik!' },
          { text: 'Overhead bin ve acil çıkışlara erişim için', isCorrect: true, feedback: '✅ Güvenlik ekipmanlarına ulaşmak şart!' },
          { text: 'Yolcuları etkilemek için', isCorrect: false, feedback: '❌ İzlenim değil, fonksiyon!' }
        ]
      }
    }
  },

  'CM-M2-U2-L2': {
    lesson_id: 'CM-M2-U2-L2',
    title: 'Sağlık Gereksinimleri',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '🏥 Sağlık Kriterleri',
      intro: 'Kabin memurluğu fiziksel dayanıklılık gerektirir',
      facts: [
        { icon: '👁️', title: 'Görme', text: 'Lens/gözlük OK, renk körlüğü NO' },
        { icon: '👂', title: 'İşitme', text: 'Normal işitme şart' },
        { icon: '🫀', title: 'Kardiyovasküler', text: 'Kalp/dolaşım sağlıklı' },
        { icon: '💪', title: 'Fiziksel', text: 'Ayakta kalma, taşıma kapasitesi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Hangisi kabul edilebilir?',
        options: [
          { text: 'Kontakt lens kullanmak', isCorrect: true, feedback: '✅ Lens ve gözlük kabul edilir!' },
          { text: 'Renk körlüğü', isCorrect: false, feedback: '❌ Renk ayrımı güvenlik için şart.' },
          { text: 'Ciddi kalp rahatsızlığı', isCorrect: false, feedback: '❌ Yüksek irtifa ve stres riski.' }
        ]
      }
    }
  },

  'CM-M2-U2-L3': {
    lesson_id: 'CM-M2-U2-L3',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'Minimum arm reach genellikle kaç cm?', options: ['180 cm', '200 cm', '212 cm', '220 cm'], correct: 2 },
        { q: 'Lens kullanmak mülakat için sorun mu?', options: ['Evet, elenir', 'Hayır, kabul', 'Sadece THY\'de', 'Operasyona göre'], correct: 1 },
        { q: 'Boy kriteri neden var?', options: ['Estetik', 'Güvenlik', 'Gelenek', 'Maliyet'], correct: 1 },
        { q: 'Renk körlüğü neden sorun?', options: ['Güzellik', 'Güvenlik işaretleri', 'Tercih', 'Önemsiz'], correct: 1 }
      ]
    }
  },

  // ==================== ÜNİTE 3: KİŞİLİK ÖZELLİKLERİ ====================
  'CM-M2-U3-L1': {
    lesson_id: 'CM-M2-U3-L1',
    title: 'Aranan Kişilik Özellikleri',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🧠 İdeal Kabin Memuru Kişiliği',
      intro: 'Havayollarının aradığı özellikler',
      categories: [
        { icon: '😊', title: 'Empati', examples: 'Yolcuyu anlama', desc: 'Duygusal zeka' },
        { icon: '🔄', title: 'Esneklik', examples: 'Değişime uyum', desc: 'Adaptasyon yeteneği' },
        { icon: '😌', title: 'Stres Yönetimi', examples: 'Baskı altında sakin', desc: 'Soğukkanlılık' },
        { icon: '🤝', title: 'Takım Oyuncusu', examples: 'Birlikte çalışma', desc: 'İşbirliği' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Havayolu mülakatında en çok aranan özellik?',
        options: [
          { text: 'Teknik bilgi', isCorrect: false, feedback: '❌ Teknik eğitimle öğretilir.' },
          { text: 'Empati ve takım çalışması', isCorrect: true, feedback: '✅ Kişilik değiştirilemez, teknik öğretilebilir!' },
          { text: 'Güzellik', isCorrect: false, feedback: '❌ Grooming standartları var ama asıl kriter bu değil.' }
        ]
      }
    }
  },

  'CM-M2-U3-L2': {
    lesson_id: 'CM-M2-U3-L2',
    title: 'Kültürel Farkındalık',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🌍 Kültürel Duyarlılık',
      intro: 'Farklı kültürlerden yolculara hizmet',
      facts: [
        { icon: '🍽️', title: 'Yemek', text: 'Helal, Kosher, Vegan tercihler' },
        { icon: '🙏', title: 'İnanç', text: 'Dini hassasiyetlere saygı' },
        { icon: '🤝', title: 'Selamlaşma', text: 'Kültüre göre değişen tarzlar' },
        { icon: '👔', title: 'Kıyafet', text: 'Muhafazakar vs liberal farklılıklar' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Bir yolcu özel yemek isterse?',
        options: [
          { text: 'Sadece normal menü var derim', isCorrect: false, feedback: '❌ Özel yemekler (SPML) sipariş edilebilir!' },
          { text: 'Anlayışla karşılar, alternatif sunarım', isCorrect: true, feedback: '✅ MOML, VGML, KSML gibi özel yemek kodları var!' },
          { text: 'Komik bulurum', isCorrect: false, feedback: '❌ Kültürel saygısızlık!' }
        ]
      }
    }
  },

  'CM-M2-U3-L3': {
    lesson_id: 'CM-M2-U3-L3',
    title: 'Senaryo: Kültürel Durum',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      question: '🌍 SENARYO: Kültürel Hassasiyet',
      context: 'Bir yolcu sizin servis sıranızda helal yemek istiyor ama önceden sipariş vermemiş. Normal yemekte domuz eti var.',
      options: [
        { id: 'A', text: 'Özür diler, alternatif seçenekleri sunar ve galley\'den uygun bir şey bulmaya çalışırım', isCorrect: true },
        { id: 'B', text: '"Sipariş etmeliydiniz" der geçerim', isCorrect: false },
        { id: 'C', text: 'Normal yemeği veririm, fark etmez', isCorrect: false },
        { id: 'D', text: 'Yemek vermem', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Çözüm odaklı yaklaşım ve kültürel saygı!',
        wrong: '❌ Kültürel hassasiyetlere saygı göstermek ve çözüm aramak şart.'
      },
      explanation: 'Galley\'de meyve, peynir, ekmek gibi alternatifler olabilir. Yolcuyu yemeksiz bırakmayın.'
    }
  },

  'CM-M2-U3-L4': {
    lesson_id: 'CM-M2-U3-L4',
    title: '🎮 Kişilik Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      instruction: 'Özellikleri tanımlarıyla eşleştir',
      pairs: [
        { id: 1, left: 'Empati', right: 'Yolcunun duygularını anlama' },
        { id: 2, left: 'Esneklik', right: 'Değişen koşullara uyum' },
        { id: 3, left: 'Stres Yönetimi', right: 'Baskı altında sakin kalma' },
        { id: 4, left: 'Takım Çalışması', right: 'Birlikte işbirliği yapma' },
        { id: 5, left: 'Kültürel Farkındalık', right: 'Farklı geleneklere saygı' }
      ]
    }
  },

  // ==================== ÜNİTE 4: DİL VE İLETİŞİM ====================
  'CM-M2-U4-L1': {
    lesson_id: 'CM-M2-U4-L1',
    title: 'İngilizce Gereksinimleri',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🇬🇧 İngilizce Seviyesi',
      intro: 'Havacılıkta ortak dil İngilizcedir',
      facts: [
        { icon: '📊', title: 'Minimum', text: 'B2 (Upper-Intermediate) seviye' },
        { icon: '🎤', title: 'Konuşma', text: 'Akıcı ve anlaşılır' },
        { icon: '📢', title: 'Anons', text: 'Net telaffuz önemli' },
        { icon: '🆘', title: 'Acil Durum', text: 'Stres altında İngilizce' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Havacılıkta neden İngilizce şart?',
        options: [
          { text: 'Havayolu tercihi', isCorrect: false, feedback: '❌ Tercih değil, zorunluluk!' },
          { text: 'Uluslararası standart ve güvenlik', isCorrect: true, feedback: '✅ ICAO standardı, tüm dünyada ortak!' },
          { text: 'Sadece prestij için', isCorrect: false, feedback: '❌ Güvenlik ve iletişim için!' }
        ]
      }
    }
  },

  'CM-M2-U4-L2': {
    lesson_id: 'CM-M2-U4-L2',
    title: 'İkinci Dil Avantajı',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🌐 Çoklu Dil Avantajı',
      intro: 'Ekstra dil = Ekstra şans!',
      facts: [
        { icon: '🇩🇪', title: 'Almanca', text: 'Avrupa rotaları için avantaj' },
        { icon: '🇫🇷', title: 'Fransızca', text: 'Afrika, Kanada rotaları' },
        { icon: '🇪🇸', title: 'İspanyolca', text: 'Amerika rotaları' },
        { icon: '🇯🇵', title: 'Japonca/Çince', text: 'Asya rotaları premium' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İkinci dil bilmek ne sağlar?',
        options: [
          { text: 'Sadece CV için güzel görünür', isCorrect: false, feedback: '❌ Gerçek operasyonel avantaj sağlar!' },
          { text: 'Belirli rotalara atanma şansı artar', isCorrect: true, feedback: '✅ Almanca biliyorsanız Frankfurt rotası öncelik!' },
          { text: 'Hiçbir fark yaratmaz', isCorrect: false, feedback: '❌ Büyük avantaj sağlar!' }
        ]
      }
    }
  },

  'CM-M2-U4-L3': {
    lesson_id: 'CM-M2-U4-L3',
    title: 'Etkili İletişim Teknikleri',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🗣️ İletişim Teknikleri',
      intro: 'Profesyonel iletişim kuralları',
      steps: [
        { level: 1, title: '👂 Dinle', desc: 'Önce anla' },
        { level: 2, title: '🔄 Paraphrase', desc: 'Anladığını tekrarla' },
        { level: 3, title: '💡 Çözüm Sun', desc: 'Alternatifler öner' },
        { level: 4, title: '✅ Onayla', desc: 'Memnuniyeti kontrol et' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Yolcu şikayet ediyorsa ilk ne yapmalı?',
        options: [
          { text: 'Hemen savunmaya geçmeli', isCorrect: false, feedback: '❌ Savunma değil, dinleme!' },
          { text: 'Önce dinlemeli ve anlamalı', isCorrect: true, feedback: '✅ Aktif dinleme her zaman ilk adım!' },
          { text: 'Yöneticiye yönlendirmeli', isCorrect: false, feedback: '❌ Önce kendin çözmeye çalış!' }
        ]
      }
    }
  },

  'CM-M2-U4-L4': {
    lesson_id: 'CM-M2-U4-L4',
    title: '⚡ Dil Bilgisi Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Havacılıkta standart dil?', options: ['Almanca', 'İngilizce', 'Fransızca', 'İspanyolca'], correct: 1 },
        { q: 'Minimum İngilizce seviyesi?', options: ['A1', 'A2', 'B1', 'B2'], correct: 3 },
        { q: 'İletişimde ilk adım?', options: ['Konuşmak', 'Dinlemek', 'Yazmak', 'Okumak'], correct: 1 },
        { q: 'ICAO ne demek?', options: ['Uçak şirketi', 'Havacılık örgütü', 'Pilot sendikası', 'Yolcu derneği'], correct: 1 },
        { q: 'Hangi dil Avrupa rotalarında avantaj?', options: ['Çince', 'Almanca', 'Japonca', 'Korece'], correct: 1 }
      ]
    }
  },

  // ==================== ÜNİTE 5: GÖRÜNÜM VE GROOMING ====================
  'CM-M2-U5-L1': {
    lesson_id: 'CM-M2-U5-L1',
    title: 'Grooming Standartları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '💅 Profesyonel Görünüm',
      intro: 'Havayolu grooming kuralları',
      facts: [
        { icon: '💇‍♀️', title: 'Saç', text: 'Temiz, düzenli, doğal renkler' },
        { icon: '💄', title: 'Makyaj', text: 'Doğal ve profesyonel' },
        { icon: '💅', title: 'Tırnaklar', text: 'Bakımlı, uygun uzunlukta' },
        { icon: '👔', title: 'Kıyafet', text: 'Ütülü, lekesiz, fit' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakatta saç rengi nasıl olmalı?',
        options: [
          { text: 'Parlak pembe/mavi', isCorrect: false, feedback: '❌ Sıra dışı renkler genelde kabul edilmez!' },
          { text: 'Doğal tonlar (sarı, kahverengi, siyah)', isCorrect: true, feedback: '✅ Profesyonel ve doğal görünüm!' },
          { text: 'Farketmez', isCorrect: false, feedback: '❌ Grooming kuralları kesin!' }
        ]
      }
    }
  },

  'CM-M2-U5-L2': {
    lesson_id: 'CM-M2-U5-L2',
    title: 'Mülakat Görünümü',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '👗 Mülakat Günü Görünümü',
      intro: 'İlk izlenim için şansınız bir kez!',
      categories: [
        { icon: '👩', title: 'Kadın', examples: 'Topuz, doğal makyaj, kalem etek', desc: 'Klasik ve profesyonel' },
        { icon: '👨', title: 'Erkek', examples: 'Kısa saç, tıraşlı, takım elbise', desc: 'Temiz ve bakımlı' },
        { icon: '👠', title: 'Ayakkabı', examples: 'Klasik, temiz, rahat', desc: 'Topuklu veya loafer' },
        { icon: '💼', title: 'Aksesuar', examples: 'Minimal', desc: 'Az ve şık' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakatta ideal kıyafet?',
        options: [
          { text: 'Günlük, rahat kıyafetler', isCorrect: false, feedback: '❌ Çok casual!' },
          { text: 'Kalem etek/pantolon + blazer veya takım elbise', isCorrect: true, feedback: '✅ Profesyonel ve şık!' },
          { text: 'Çok süslü gece elbisesi', isCorrect: false, feedback: '❌ Aşırı şık!' }
        ]
      }
    }
  },

  'CM-M2-U5-L3': {
    lesson_id: 'CM-M2-U5-L3',
    title: '🎮 Grooming Doğru/Yanlış',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Mülakatta parlak kırmızı oje sürülebilir.', isTrue: false, explanation: '❌ Nude veya şeffaf ton tercih edilmeli!' },
        { statement: 'Erkek adaylar sakal bırakabilir.', isTrue: false, explanation: '❌ Çoğu havayolu temiz tıraş ister!' },
        { statement: 'Saç topuz yapılmalıdır (kadın).', isTrue: true, explanation: '✅ Klasik topuz profesyonel görünüm!' },
        { statement: 'Dövme görünür yerde olabilir.', isTrue: false, explanation: '❌ Dövmeler kapatılmalı!' },
        { statement: 'Minimal aksesuar tercih edilmeli.', isTrue: true, explanation: '✅ Az ve şık aksesuar!' }
      ]
    }
  },

  // ==================== ÜNİTE 6: FİNAL QUIZ ====================
  'CM-M2-U6-L1': {
    lesson_id: 'CM-M2-U6-L1',
    title: '🎓 Modül 2 Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'Takım uyumu neden önemli?', options: ['Sosyal için', 'Uçuş güvenliği için', 'Maaş için', 'Eğlence için'], correct: 1 },
        { q: 'Minimum arm reach genellikle?', options: ['180 cm', '200 cm', '212 cm', '250 cm'], correct: 2 },
        { q: 'İngilizce minimum seviye?', options: ['A1', 'A2', 'B1', 'B2'], correct: 3 },
        { q: 'Mülakatta ideal saç rengi?', options: ['Mavi', 'Pembe', 'Doğal tonlar', 'Mor'], correct: 2 },
        { q: 'Grooming nedir?', options: ['Temizlik', 'Profesyonel görünüm', 'Makyaj', 'Kıyafet'], correct: 1 },
        { q: 'Kültürel farkındalık neden önemli?', options: ['Merak', 'Yolcu memnuniyeti', 'Zorunluluk', 'Tercih'], correct: 1 },
        { q: 'İletişimde ilk adım?', options: ['Konuşmak', 'Dinlemek', 'Sormak', 'Cevaplamak'], correct: 1 },
        { q: 'Havacılıkta ortak dil?', options: ['Türkçe', 'Almanca', 'İngilizce', 'Fransızca'], correct: 2 },
        { q: 'SPML ne demek?', options: ['Özel yemek', 'Özel koltuk', 'Özel bagaj', 'Özel servis'], correct: 0 },
        { q: 'Empati nedir?', options: ['Sempati', 'Yolcuyu anlama', 'Acıma', 'İlgisizlik'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM2Interactive;
